import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { HlPercentageDTO } from './dto/hl-percentage.dto';
import { AllHlPercentageResponseModel, HlPercentageRequest, HlPercentageResponseModel } from '@gtpl/shared-models/masters';
import { HlPercentagesService } from './hl-percentages.service';
import { HlPercentageRangeRequest } from './dto/hl-percentage-range.request';
import { UserRequestDto } from '@gtpl/shared-models/common-models';


@ApiTags('hl-percentages')
@Controller('hl-percentages')
export class HlPercentagesController {

    constructor(
        private hlPercentageService: HlPercentagesService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler

    ){}
    @Post('/createHlPercentage')
    async createHlPercentage(@Body() hlPercentageDto:HlPercentageDTO,isUpdate:boolean=false): Promise<HlPercentageResponseModel> {
    try {
        return await this.hlPercentageService.createHlPercentage(hlPercentageDto, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(HlPercentageResponseModel, error);
      }
    }
    @Post('/updateHlPercentage')
  async updateGrade(@Body() hlPercentageDto: HlPercentageDTO,@Req() request:Request): Promise<HlPercentageResponseModel> {
    try {
      console.log('update HlPercentage');hlPercentageDto
      console.log(request);
      return await this.hlPercentageService.createHlPercentage(hlPercentageDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(HlPercentageResponseModel, error);
    }
  }
  @Post('/getAllHlPercentage')
  // @UseGuards(AuthGuard('jwt'))
  async getAllHlPercentage(@Body() req?:UserRequestDto): Promise<AllHlPercentageResponseModel> {
    try {
      return await this.hlPercentageService.getAllHlPercentage(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllHlPercentageResponseModel, error);
    }
  }
  @Post('/activateOrDeactivateHlPercentage')
  async activateOrDeactivateHlPercentage(@Body() hlPercentagereq: HlPercentageRequest): Promise<HlPercentageResponseModel> {
      try {
          return await this.hlPercentageService.activateOrDeactivateHlPercentage(hlPercentagereq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(HlPercentageResponseModel, err);
      }
  }
  @Post('/getAllActiveHlPercentage')
  async getAllActiveHlPercentage(@Req() request: Request): Promise<AllHlPercentageResponseModel> {
      try {
          return await this.hlPercentageService.getAllActiveHlPercentage();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllHlPercentageResponseModel, error)
      }
  }
  @Post('/getHlPercentageById')
  async getHlPercentageById(@Body() hlPercentagereq: HlPercentageRequest): Promise<HlPercentageResponseModel> {
      try {
          return await this.hlPercentageService.getActiveHlPercentageById(hlPercentagereq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(HlPercentageResponseModel, err);
      }
  }

  /*
  to get the hl percentage between grade range
  */

  @Post('/getHlPercentageByRange')
  async getHlPercentageByRange(@Body() hlPerReq: HlPercentageRangeRequest): Promise<HlPercentageResponseModel> {
      try {
          return await this.hlPercentageService.getHlPercentageByRange(hlPerReq);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(HlPercentageResponseModel, err);
      }
  }
}


